import styled, { createGlobalStyle } from "styled-components";

export const AdvancedFiltersWrapper = styled.div`
  margin: 5px 0px;
`;

export const AdvancedFiltersSelectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const Filter = styled.div`
  padding: 5px;
`;
export const StyledFilterInput = styled.div`
  padding: 5px;
`;
export const StyledFilter = styled(Filter)`
  margin: 15px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: end;
  max-width: 250px;
`;
export const AdvancedFilterStyles = createGlobalStyle`
  .ids-menu-container {
    height: 350px;
    overflow-y: scroll;
  }
`;
